import { ClientRequest } from "http";
import { Errback } from "./types";

export default require("xhr") as (
  options: any,
  cb: Errback<Response>
) => ClientRequest;



// WEBPACK FOOTER //
// ./src/util/xhr.ts